import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/shin_light.png'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, _cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      src: _imports_0,
      draggable: "false"
    }, null, -1),
    _createElementVNode("b", null, "Summary of your work on github", -1),
    _createElementVNode("p", null, "Written in Vue and Gin", -1)
  ])))
}